// extracted by mini-css-extract-plugin
export default {"common":"styles_common__hXWw1","box":"styles_box__FcG3Q","column":"styles_column__36pFv","row":"styles_row__BlH9x","grid":"styles_grid__OzWZk","absolute":"styles_absolute__T5+2s"};